import { max } from 'd3-array';
import {
  ISocialPostTrends,
  ITrendData,
} from '../SocialArtistPerformanceTrend/types';

export { getInitialPeriod };

/**
 * This helper returns the latest (max) timestamp from the array of trends.
 *
 * @param {array} trends SocialPostPerformanceTrend trend line arrays
 * @returns {Date}
 */
function getInitialPeriod(trends: ISocialPostTrends[]): Date | undefined {
  if (!trends) return;
  const dates = trends.flatMap((trend) =>
    trend.data.map((d: ITrendData) => d.periodKey)
  );
  const maxDate = max(dates);
  return maxDate;
}
